import { render, staticRenderFns } from "./ComponentHeader.vue?vue&type=template&id=713a93de&scoped=true"
import script from "./ComponentHeader.vue?vue&type=script&lang=ts"
export * from "./ComponentHeader.vue?vue&type=script&lang=ts"
import style0 from "./ComponentHeader.vue?vue&type=style&index=0&id=713a93de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713a93de",
  null
  
)

export default component.exports